import PaperSelect from './module/paperSelect';

export { PaperSelect };
